const SELECTOR_HEADER = '.js-header.header_mod_overlay';
const SELECTOR_ACTIVE_PANEL = '.js-scroll-stack-panel:not([data-panel-state="hidden"])';
const ATTR_SCROLLED = 'data-scrolled';

function hasPanelScrollOffset(): boolean {
  const panels = document.querySelectorAll<HTMLElement>(SELECTOR_ACTIVE_PANEL);

  return Array.from(panels).some(panel => panel.scrollTop > 0);
}

export function initHeaderScroll(): void {
  if (typeof window === 'undefined')
    return;

  const header = document.querySelector<HTMLElement>(SELECTOR_HEADER);
  if (header === null)
    return;

  let scrolled = false;
  let ticking = false;

  const isScrolled = (): boolean => window.scrollY > 0 || hasPanelScrollOffset();

  const update = (): void => {
    const next = isScrolled();
    if (next === scrolled)
      return;

    scrolled = next;
    header.toggleAttribute(ATTR_SCROLLED, scrolled);
  };

  const requestUpdate = (): void => {
    if (ticking)
      return;

    ticking = true;
    window.requestAnimationFrame(() => {
      ticking = false;
      update();
    });
  };

  document.addEventListener('scroll', requestUpdate, { capture: true, passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });

  update();
}
